import React, { memo, useState } from "react";
import { Stack } from "investira.react.components";
import DetalheTable from "../DetalheTable";
import EmissorDetalhesDialog from "./EmissorDetalhesDialog";

const Emissor = memo((props) => {
  const { detalhe, variant } = props;
  const [emissor, setEmissor] = useState({});

  return (
    <Stack spacing={4}>
      <DetalheTable detalhe={detalhe} onSetEmissor={setEmissor} />
      <EmissorDetalhesDialog
        detalhe={detalhe}
        emissor={emissor}
        onSetEmissor={setEmissor}
        variant={variant}
      />
    </Stack>
  );
});

Emissor.displayName = "Emissor";

export default Emissor;
